import { Button } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { ClientMigrations } from "slot-definitions"
import { ClientDataMigrationDialog } from "../../client-data-migration-dialog"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getLegacyCustomSchedules } from "./controller/get-legacy-custom-schedules"
import { migrationResultSnackbar } from "../../migration-result-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { importLegacyCustomSchedules } from "./controller/import-legacy-custom-schedules"
import { invalidate } from "lib/graphql/cache"

const CUSTOM_DATA_MIGRATION_SCHEDULES = "custom schedules"

ClientMigrations.plug(<LegacyCustomSchedules priority={300} />)

function LegacyCustomSchedules() {
    const { subscriptionId } = useBoundContext()
    const dialog = useDialog(
        <ClientDataMigrationDialog
            type={CUSTOM_DATA_MIGRATION_SCHEDULES}
            subscriptionId={subscriptionId}
            query={getLegacyCustomSchedules}
            getKey={(d) => d.customScheduleId}
            transform={(d) => ({ ...d, label: `${d.label} (#${d.code})` })}
            warning={"Only approved schedules will be migrated."}
        />,
        // A fixed height stops the dialog resizing and re-centring as the search narrows the list
        { maxWidth: "lg", sx: { height: { md: "85vh" } } }
    )

    return (
        <Button
            variant="outlined"
            size="large"
            onClick={handleMigrate}
            startIcon={<Iconify icon={"ion:documents"} />}
            data-cy="migrate-approved-custom-schedules"
        >
            Custom Schedules (Approved)
        </Button>
    )

    async function handleMigrate() {
        const data = await dialog()
        if (data && data.length > 0) {
            try {
                const selectedIds = data.map("customScheduleId")
                const result = await importLegacyCustomSchedules(subscriptionId, selectedIds)
                invalidate("getLegacyCustomSchedules")
                migrationResultSnackbar(result, "custom schedule")
            } catch (error) {
                errorSnackbar("Error migrating custom schedules")
            }
        }
    }
}
